import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ibe/ui-web';

import { useTranslation } from '../../../shared/use-translation.js';
import { SignInForm } from './sign-in-form.js';

// In-context guest sign-in — keeps the guest on the current page (room rates,
// checkout) instead of routing to /auth/sign-in. Signing in re-prices member
// rates automatically through the stored access token.
export function SignInDialog({
  open,
  onOpenChange,
  onJoin,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  /** Swaps to the join dialog when the host mounts both. */
  readonly onJoin?: (() => void) | undefined;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="text-center">
          <DialogTitle>{t('auth.signIn.title')}</DialogTitle>
          <DialogDescription>{t('auth.signIn.subtitle')}</DialogDescription>
        </DialogHeader>
        <div className="mt-6">
          <SignInForm
            onSuccess={() => {
              onOpenChange(false);
            }}
          />
        </div>
        <p className="mt-6 rounded-md bg-primary-container px-3 py-2 text-center text-xs leading-relaxed text-on-primary-container">
          {t('roomRate.notMemberYet')}
          {onJoin !== undefined && (
            <>
              {' '}
              <button
                type="button"
                onClick={onJoin}
                className="font-semibold underline hover:no-underline"
              >
                {t('roomRate.joinFree')}
              </button>
            </>
          )}
        </p>
      </DialogContent>
    </Dialog>
  );
}
